var map = {
	"./chirpie/act1/0.png": 21381,
	"./chirpie/act1/1.png": 7675,
	"./chirpie/act1/2.png": 3656,
	"./chirpie/act1/3.png": 96074,
	"./chirpie/act1/4.png": 52354,
	"./chirpie/act1/5.png": 48564,
	"./chirpie/act1/6.png": 61035,
	"./chirpie/act1/7.png": 72321,
	"./chirpie/act1/8.png": 23791,
	"./chirpie/act1/9.png": 21977,
	"./chirpie/act2/0.png": 45840,
	"./chirpie/act2/1.png": 64210,
	"./chirpie/act2/2.png": 19415,
	"./chirpie/act2/3.png": 73847,
	"./chirpie/act2/4.png": 89071,
	"./chirpie/act2/5.png": 18521,
	"./chirpie/act2/6.png": 69221,
	"./chirpie/act2/7.png": 43627,
	"./chirpie/act2/8.png": 41714,
	"./chirpie/act2/9.png": 37974,
	"./chirpie/idle/0.png": 66545,
	"./chirpie/idle/1.png": 35402,
	"./chirpie/idle/10.png": 91834,
	"./chirpie/idle/2.png": 29124,
	"./chirpie/idle/3.png": 62057,
	"./chirpie/idle/4.png": 21607,
	"./chirpie/idle/5.png": 14091,
	"./chirpie/idle/6.png": 35382,
	"./chirpie/idle/7.png": 63962,
	"./chirpie/idle/8.png": 21047,
	"./chirpie/idle/9.png": 74926,
	"./chirpie/tap/0.png": 41747,
	"./chirpie/tap/1.png": 87699,
	"./chirpie/tap/2.png": 8011,
	"./chirpie/tap/3.png": 73696,
	"./chirpie/tap/4.png": 86919,
	"./chirpie/tap/5.png": 70175,
	"./chirpie/tap/6.png": 141,
	"./chirpie/tap/7.png": 94404,
	"./chirpie/tap/8.png": 40825,
	"./chirpie/tap/9.png": 61642,
	"./dali/act1/0.png": 3539,
	"./dali/act1/1.png": 48141,
	"./dali/act1/10.png": 83111,
	"./dali/act1/2.png": 3330,
	"./dali/act1/3.png": 81425,
	"./dali/act1/4.png": 77756,
	"./dali/act1/5.png": 49456,
	"./dali/act1/6.png": 38855,
	"./dali/act1/7.png": 31836,
	"./dali/act1/8.png": 94806,
	"./dali/act1/9.png": 80311,
	"./dali/act2/0.png": 98014,
	"./dali/act2/1.png": 83577,
	"./dali/act2/10.png": 78765,
	"./dali/act2/2.png": 21840,
	"./dali/act2/3.png": 72974,
	"./dali/act2/4.png": 57497,
	"./dali/act2/5.png": 86832,
	"./dali/act2/6.png": 37441,
	"./dali/act2/7.png": 21980,
	"./dali/act2/8.png": 99078,
	"./dali/act2/9.png": 56898,
	"./dali/act3/0.png": 9167,
	"./dali/act3/1.png": 53044,
	"./dali/act3/2.png": 85497,
	"./dali/act3/3.png": 686,
	"./dali/act3/4.png": 34303,
	"./dali/act3/5.png": 30338,
	"./dali/act3/6.png": 8626,
	"./dali/act3/7.png": 23698,
	"./dali/act3/8.png": 29937,
	"./dali/idle/0.png": 3907,
	"./dali/idle/1.png": 35358,
	"./dali/idle/2.png": 54292,
	"./dali/idle/3.png": 85326,
	"./dali/idle/4.png": 59660,
	"./dali/idle/5.png": 27034,
	"./dali/idle/6.png": 96161,
	"./dali/tap/0.png": 60790,
	"./dali/tap/1.png": 22250,
	"./dali/tap/2.png": 75671,
	"./dali/tap/3.png": 16503,
	"./dali/tap/4.png": 95485,
	"./dali/tap/5.png": 60896,
	"./dali/tap/6.png": 19766,
	"./dali/tap/7.png": 12171,
	"./donut/act1/0.png": 11253,
	"./donut/act1/1.png": 95205,
	"./donut/act1/2.png": 92074,
	"./donut/act1/3.png": 3914,
	"./donut/act1/4.png": 98275,
	"./donut/act1/5.png": 57456,
	"./donut/act1/6.png": 75371,
	"./donut/act1/7.png": 12632,
	"./donut/act1/8.png": 35719,
	"./donut/idle/0.png": 16432,
	"./donut/idle/1.png": 87793,
	"./donut/idle/2.png": 61679,
	"./donut/idle/3.png": 88204,
	"./donut/idle/4.png": 12332,
	"./donut/idle/5.png": 63345,
	"./donut/idle/6.png": 2330,
	"./donut/idle/7.png": 50551,
	"./donut/idle/8.png": 62082,
	"./donut/tap/0.png": 38845,
	"./donut/tap/1.png": 80597,
	"./donut/tap/2.png": 2564,
	"./donut/tap/3.png": 33842,
	"./donut/tap/4.png": 89172,
	"./donut/tap/5.png": 97404,
	"./donut/tap/6.png": 79306,
	"./donut/tap/7.png": 90687,
	"./donut/tap/8.png": 58280,
	"./echo_delay/act1/0.png": 1063,
	"./echo_delay/act1/1.png": 34678,
	"./echo_delay/act1/10.png": 93263,
	"./echo_delay/act1/11.png": 86577,
	"./echo_delay/act1/2.png": 8156,
	"./echo_delay/act1/3.png": 28142,
	"./echo_delay/act1/4.png": 27339,
	"./echo_delay/act1/5.png": 46805,
	"./echo_delay/act1/6.png": 83633,
	"./echo_delay/act1/7.png": 37570,
	"./echo_delay/act1/8.png": 19260,
	"./echo_delay/act1/9.png": 50299,
	"./echo_delay/act2/0.png": 47332,
	"./echo_delay/act2/1.png": 45990,
	"./echo_delay/act2/10.png": 58078,
	"./echo_delay/act2/2.png": 73864,
	"./echo_delay/act2/3.png": 45562,
	"./echo_delay/act2/4.png": 9738,
	"./echo_delay/act2/5.png": 14106,
	"./echo_delay/act2/6.png": 83159,
	"./echo_delay/act2/7.png": 25032,
	"./echo_delay/act2/8.png": 6750,
	"./echo_delay/act2/9.png": 74143,
	"./echo_delay/act3/0.png": 33869,
	"./echo_delay/act3/1.png": 3961,
	"./echo_delay/act3/2.png": 92090,
	"./echo_delay/act3/3.png": 85594,
	"./echo_delay/act3/4.png": 36783,
	"./echo_delay/act3/5.png": 70552,
	"./echo_delay/act3/6.png": 73695,
	"./echo_delay/act3/7.png": 25365,
	"./echo_delay/act4/0.png": 85682,
	"./echo_delay/act4/1.png": 85893,
	"./echo_delay/act4/2.png": 50581,
	"./echo_delay/act4/3.png": 62746,
	"./echo_delay/act4/4.png": 16297,
	"./echo_delay/act4/5.png": 66277,
	"./echo_delay/act4/6.png": 68374,
	"./echo_delay/act4/7.png": 16768,
	"./echo_delay/act4/8.png": 40105,
	"./echo_delay/act4/9.png": 99596,
	"./echo_delay/act5/0.png": 40897,
	"./echo_delay/act5/1.png": 35583,
	"./echo_delay/act5/2.png": 39791,
	"./echo_delay/act5/3.png": 13035,
	"./echo_delay/act5/4.png": 86476,
	"./echo_delay/act5/5.png": 58112,
	"./echo_delay/act5/6.png": 36444,
	"./echo_delay/act5/7.png": 33099,
	"./echo_delay/act5/8.png": 97507,
	"./echo_delay/act5/9.png": 63324,
	"./echo_delay/idle/0.png": 8426,
	"./echo_delay/idle/1.png": 52876,
	"./echo_delay/idle/10.png": 37146,
	"./echo_delay/idle/2.png": 68446,
	"./echo_delay/idle/3.png": 24290,
	"./echo_delay/idle/4.png": 32823,
	"./echo_delay/idle/5.png": 6444,
	"./echo_delay/idle/6.png": 68939,
	"./echo_delay/idle/7.png": 59531,
	"./echo_delay/idle/8.png": 39289,
	"./echo_delay/idle/9.png": 19057,
	"./echo_delay/tap/0.png": 40240,
	"./echo_delay/tap/1.png": 91294,
	"./echo_delay/tap/10.png": 69113,
	"./echo_delay/tap/2.png": 45387,
	"./echo_delay/tap/3.png": 95618,
	"./echo_delay/tap/4.png": 7529,
	"./echo_delay/tap/5.png": 73986,
	"./echo_delay/tap/6.png": 86525,
	"./echo_delay/tap/7.png": 20186,
	"./echo_delay/tap/8.png": 4780,
	"./echo_delay/tap/9.png": 34789,
	"./fann/act1/0.png": 15600,
	"./fann/act1/1.png": 11631,
	"./fann/act1/10.png": 18169,
	"./fann/act1/11.png": 4261,
	"./fann/act1/2.png": 96652,
	"./fann/act1/3.png": 86244,
	"./fann/act1/4.png": 18411,
	"./fann/act1/5.png": 27123,
	"./fann/act1/6.png": 58143,
	"./fann/act1/7.png": 61013,
	"./fann/act1/8.png": 66439,
	"./fann/act1/9.png": 17741,
	"./fann/idle/0.png": 98840,
	"./fann/idle/1.png": 69958,
	"./fann/idle/10.png": 29084,
	"./fann/idle/11.png": 53630,
	"./fann/idle/12.png": 28717,
	"./fann/idle/2.png": 59372,
	"./fann/idle/3.png": 22131,
	"./fann/idle/4.png": 65702,
	"./fann/idle/5.png": 54309,
	"./fann/idle/6.png": 73615,
	"./fann/idle/7.png": 38763,
	"./fann/idle/8.png": 54823,
	"./fann/idle/9.png": 87976,
	"./fann/tap/0.png": 28235,
	"./fann/tap/1.png": 17486,
	"./fann/tap/10.png": 72665,
	"./fann/tap/2.png": 32563,
	"./fann/tap/3.png": 57928,
	"./fann/tap/4.png": 39486,
	"./fann/tap/5.png": 79001,
	"./fann/tap/6.png": 44218,
	"./fann/tap/7.png": 65710,
	"./fann/tap/8.png": 96693,
	"./fann/tap/9.png": 44773,
	"./fluffy/act1/0.png": 74662,
	"./fluffy/act1/1.png": 88798,
	"./fluffy/act1/10.png": 60251,
	"./fluffy/act1/2.png": 77117,
	"./fluffy/act1/3.png": 68910,
	"./fluffy/act1/4.png": 97957,
	"./fluffy/act1/5.png": 5401,
	"./fluffy/act1/6.png": 39029,
	"./fluffy/act1/7.png": 71485,
	"./fluffy/act1/8.png": 58959,
	"./fluffy/act1/9.png": 57009,
	"./fluffy/act2/0.png": 5135,
	"./fluffy/act2/1.png": 56594,
	"./fluffy/act2/10.png": 64218,
	"./fluffy/act2/2.png": 3882,
	"./fluffy/act2/3.png": 30430,
	"./fluffy/act2/4.png": 39174,
	"./fluffy/act2/5.png": 69532,
	"./fluffy/act2/6.png": 65491,
	"./fluffy/act2/7.png": 25802,
	"./fluffy/act2/8.png": 6247,
	"./fluffy/act2/9.png": 56794,
	"./fluffy/idle/0.png": 30356,
	"./fluffy/idle/1.png": 83515,
	"./fluffy/idle/10.png": 78877,
	"./fluffy/idle/2.png": 14667,
	"./fluffy/idle/3.png": 2494,
	"./fluffy/idle/4.png": 18737,
	"./fluffy/idle/5.png": 79514,
	"./fluffy/idle/6.png": 93049,
	"./fluffy/idle/7.png": 64175,
	"./fluffy/idle/8.png": 28972,
	"./fluffy/idle/9.png": 28330,
	"./fluffy/tap/0.png": 14644,
	"./fluffy/tap/1.png": 34560,
	"./fluffy/tap/10.png": 54399,
	"./fluffy/tap/2.png": 46807,
	"./fluffy/tap/3.png": 17389,
	"./fluffy/tap/4.png": 90167,
	"./fluffy/tap/5.png": 57498,
	"./fluffy/tap/6.png": 34723,
	"./fluffy/tap/7.png": 16864,
	"./fluffy/tap/8.png": 12177,
	"./fluffy/tap/9.png": 9156,
	"./fuyu/act1/0.png": 10906,
	"./fuyu/act1/1.png": 10023,
	"./fuyu/act1/10.png": 98846,
	"./fuyu/act1/2.png": 33311,
	"./fuyu/act1/3.png": 58584,
	"./fuyu/act1/4.png": 24880,
	"./fuyu/act1/5.png": 35245,
	"./fuyu/act1/6.png": 17534,
	"./fuyu/act1/7.png": 19091,
	"./fuyu/act1/8.png": 33638,
	"./fuyu/act1/9.png": 85660,
	"./fuyu/act2/0.png": 54937,
	"./fuyu/act2/1.png": 68532,
	"./fuyu/act2/10.png": 86784,
	"./fuyu/act2/2.png": 35708,
	"./fuyu/act2/3.png": 20512,
	"./fuyu/act2/4.png": 27617,
	"./fuyu/act2/5.png": 93435,
	"./fuyu/act2/6.png": 67433,
	"./fuyu/act2/7.png": 91525,
	"./fuyu/act2/8.png": 7948,
	"./fuyu/act2/9.png": 67249,
	"./fuyu/idle/0.png": 82081,
	"./fuyu/idle/1.png": 58678,
	"./fuyu/idle/2.png": 17119,
	"./fuyu/idle/3.png": 87505,
	"./fuyu/idle/4.png": 32278,
	"./fuyu/idle/5.png": 63474,
	"./fuyu/idle/6.png": 52018,
	"./fuyu/idle/7.png": 67390,
	"./fuyu/idle/8.png": 16590,
	"./fuyu/tap/0.png": 62384,
	"./fuyu/tap/1.png": 82158,
	"./fuyu/tap/2.png": 61874,
	"./fuyu/tap/3.png": 36333,
	"./fuyu/tap/4.png": 18045,
	"./fuyu/tap/5.png": 91252,
	"./fuyu/tap/6.png": 17440,
	"./fuyu/tap/7.png": 78375,
	"./fuyu/tap/8.png": 3526,
	"./fuyu/tap/9.png": 32584,
	"./karl/act1/0.png": 70559,
	"./karl/act1/1.png": 10689,
	"./karl/act1/10.png": 63915,
	"./karl/act1/2.png": 26120,
	"./karl/act1/3.png": 41387,
	"./karl/act1/4.png": 96318,
	"./karl/act1/5.png": 60907,
	"./karl/act1/6.png": 12225,
	"./karl/act1/7.png": 70133,
	"./karl/act1/8.png": 26131,
	"./karl/act1/9.png": 44818,
	"./karl/idle/0.png": 73699,
	"./karl/idle/1.png": 54622,
	"./karl/idle/10.png": 54038,
	"./karl/idle/2.png": 36953,
	"./karl/idle/3.png": 29300,
	"./karl/idle/4.png": 82343,
	"./karl/idle/5.png": 2647,
	"./karl/idle/6.png": 36726,
	"./karl/idle/7.png": 61898,
	"./karl/idle/8.png": 31688,
	"./karl/idle/9.png": 72012,
	"./karl/tap/0.png": 63086,
	"./karl/tap/1.png": 91658,
	"./karl/tap/10.png": 65713,
	"./karl/tap/2.png": 67512,
	"./karl/tap/3.png": 20202,
	"./karl/tap/4.png": 76584,
	"./karl/tap/5.png": 65596,
	"./karl/tap/6.png": 73485,
	"./karl/tap/7.png": 26827,
	"./karl/tap/8.png": 43808,
	"./karl/tap/9.png": 19000,
	"./lulu/act1/0.png": 30483,
	"./lulu/act1/1.png": 89833,
	"./lulu/act1/10.png": 9795,
	"./lulu/act1/2.png": 11912,
	"./lulu/act1/3.png": 55664,
	"./lulu/act1/4.png": 95729,
	"./lulu/act1/5.png": 56310,
	"./lulu/act1/6.png": 97140,
	"./lulu/act1/7.png": 22544,
	"./lulu/act1/8.png": 95738,
	"./lulu/act1/9.png": 3293,
	"./lulu/idle/0.png": 51767,
	"./lulu/idle/1.png": 73287,
	"./lulu/idle/2.png": 20732,
	"./lulu/idle/3.png": 28984,
	"./lulu/idle/4.png": 41766,
	"./lulu/idle/5.png": 42528,
	"./lulu/idle/6.png": 39177,
	"./lulu/idle/7.png": 11422,
	"./lulu/idle/8.png": 71446,
	"./lulu/idle/9.png": 42907,
	"./lulu/tap/0.png": 19124,
	"./lulu/tap/1.png": 94233,
	"./lulu/tap/2.png": 25239,
	"./lulu/tap/3.png": 7933,
	"./lulu/tap/4.png": 84858,
	"./lulu/tap/5.png": 55278,
	"./lulu/tap/6.png": 34776,
	"./lulu/tap/7.png": 27102,
	"./lulu/tap/8.png": 48215,
	"./lulu/tap/9.png": 51167,
	"./maggie/act1/0.png": 189,
	"./maggie/act1/1.png": 7452,
	"./maggie/act1/10.png": 50486,
	"./maggie/act1/2.png": 30583,
	"./maggie/act1/3.png": 25309,
	"./maggie/act1/4.png": 4698,
	"./maggie/act1/5.png": 67879,
	"./maggie/act1/6.png": 7102,
	"./maggie/act1/7.png": 95619,
	"./maggie/act1/8.png": 22013,
	"./maggie/act1/9.png": 27472,
	"./maggie/act2/0.png": 72429,
	"./maggie/act2/1.png": 81194,
	"./maggie/act2/10.png": 14573,
	"./maggie/act2/2.png": 86561,
	"./maggie/act2/3.png": 37160,
	"./maggie/act2/4.png": 53649,
	"./maggie/act2/5.png": 85109,
	"./maggie/act2/6.png": 31950,
	"./maggie/act2/7.png": 95490,
	"./maggie/act2/8.png": 17572,
	"./maggie/act2/9.png": 237,
	"./maggie/idle/0.png": 23491,
	"./maggie/idle/1.png": 30548,
	"./maggie/idle/10.png": 33721,
	"./maggie/idle/2.png": 60476,
	"./maggie/idle/3.png": 81787,
	"./maggie/idle/4.png": 7109,
	"./maggie/idle/5.png": 44137,
	"./maggie/idle/6.png": 20637,
	"./maggie/idle/7.png": 8624,
	"./maggie/idle/8.png": 69699,
	"./maggie/idle/9.png": 36036,
	"./maggie/tap/0.png": 65498,
	"./maggie/tap/1.png": 22892,
	"./maggie/tap/2.png": 10344,
	"./maggie/tap/3.png": 32872,
	"./maggie/tap/4.png": 82003,
	"./maggie/tap/5.png": 2378,
	"./maggie/tap/6.png": 3357,
	"./maggie/tap/7.png": 93426,
	"./marsh/act1/0.png": 44902,
	"./marsh/act1/1.png": 68249,
	"./marsh/act1/10.png": 75955,
	"./marsh/act1/2.png": 55567,
	"./marsh/act1/3.png": 50650,
	"./marsh/act1/4.png": 50662,
	"./marsh/act1/5.png": 32704,
	"./marsh/act1/6.png": 76017,
	"./marsh/act1/7.png": 69105,
	"./marsh/act1/8.png": 66172,
	"./marsh/act1/9.png": 70661,
	"./marsh/act2/0.png": 43332,
	"./marsh/act2/1.png": 76971,
	"./marsh/act2/2.png": 31005,
	"./marsh/act2/3.png": 64554,
	"./marsh/act2/4.png": 25647,
	"./marsh/act2/5.png": 30693,
	"./marsh/act2/6.png": 52399,
	"./marsh/act3/0.png": 79495,
	"./marsh/act3/1.png": 86401,
	"./marsh/act3/2.png": 52724,
	"./marsh/act3/3.png": 52682,
	"./marsh/act3/4.png": 75247,
	"./marsh/act3/5.png": 13895,
	"./marsh/act3/6.png": 25717,
	"./marsh/act3/7.png": 55508,
	"./marsh/act3/8.png": 66038,
	"./marsh/act4/0.png": 1545,
	"./marsh/act4/1.png": 66587,
	"./marsh/act4/2.png": 16792,
	"./marsh/act4/3.png": 97042,
	"./marsh/act4/4.png": 20990,
	"./marsh/act4/5.png": 10443,
	"./marsh/act4/6.png": 70968,
	"./marsh/act4/7.png": 10645,
	"./marsh/act4/8.png": 24844,
	"./marsh/act5/0.png": 73012,
	"./marsh/act5/1.png": 37757,
	"./marsh/act5/2.png": 17657,
	"./marsh/act5/3.png": 67082,
	"./marsh/act5/4.png": 8860,
	"./marsh/act5/5.png": 33628,
	"./marsh/act5/6.png": 26360,
	"./marsh/act5/7.png": 91103,
	"./marsh/act5/8.png": 80052,
	"./marsh/act6/0.png": 66225,
	"./marsh/act6/1.png": 46000,
	"./marsh/act6/2.png": 70623,
	"./marsh/act6/3.png": 80430,
	"./marsh/act6/4.png": 86431,
	"./marsh/act6/5.png": 37280,
	"./marsh/act6/6.png": 27633,
	"./marsh/act6/7.png": 30945,
	"./marsh/act6/8.png": 40359,
	"./marsh/act7/0.png": 59080,
	"./marsh/act7/1.png": 19210,
	"./marsh/act7/2.png": 75961,
	"./marsh/act7/3.png": 7891,
	"./marsh/act7/4.png": 31649,
	"./marsh/act7/5.png": 95594,
	"./marsh/act7/6.png": 26032,
	"./marsh/act7/7.png": 76820,
	"./marsh/act8/0.png": 94519,
	"./marsh/act8/1.png": 23943,
	"./marsh/act8/2.png": 50652,
	"./marsh/act8/3.png": 20834,
	"./marsh/act8/4.png": 92039,
	"./marsh/act8/5.png": 52813,
	"./marsh/act8/6.png": 95372,
	"./marsh/act8/7.png": 54349,
	"./marsh/act8/8.png": 83026,
	"./marsh/act8/9.png": 71844,
	"./marsh/idle/0.png": 38581,
	"./marsh/idle/1.png": 51487,
	"./marsh/idle/2.png": 69845,
	"./marsh/idle/3.png": 25212,
	"./marsh/idle/4.png": 51253,
	"./marsh/idle/5.png": 10807,
	"./marsh/tap/0.png": 84743,
	"./marsh/tap/1.png": 14883,
	"./marsh/tap/2.png": 63793,
	"./marsh/tap/3.png": 4045,
	"./marsh/tap/4.png": 68957,
	"./marsh/tap/5.png": 90698,
	"./marsh/tap/6.png": 26123,
	"./marsh/tap/7.png": 79998,
	"./marsh/tap/8.png": 96906,
	"./pisces/act1/0.png": 46138,
	"./pisces/act1/1.png": 83560,
	"./pisces/act1/10.png": 70746,
	"./pisces/act1/2.png": 1773,
	"./pisces/act1/3.png": 30666,
	"./pisces/act1/4.png": 87623,
	"./pisces/act1/5.png": 70718,
	"./pisces/act1/6.png": 57731,
	"./pisces/act1/7.png": 31346,
	"./pisces/act1/8.png": 46552,
	"./pisces/act1/9.png": 72788,
	"./pisces/act2/0.png": 16564,
	"./pisces/act2/1.png": 16395,
	"./pisces/act2/10.png": 11648,
	"./pisces/act2/2.png": 95528,
	"./pisces/act2/3.png": 86787,
	"./pisces/act2/4.png": 39928,
	"./pisces/act2/5.png": 9890,
	"./pisces/act2/6.png": 57555,
	"./pisces/act2/7.png": 8569,
	"./pisces/act2/8.png": 73352,
	"./pisces/act2/9.png": 52841,
	"./pisces/idle/0.png": 83210,
	"./pisces/idle/1.png": 73267,
	"./pisces/idle/10.png": 52921,
	"./pisces/idle/11.png": 53990,
	"./pisces/idle/12.png": 63819,
	"./pisces/idle/13.png": 4894,
	"./pisces/idle/2.png": 23336,
	"./pisces/idle/3.png": 3825,
	"./pisces/idle/4.png": 3944,
	"./pisces/idle/5.png": 27001,
	"./pisces/idle/6.png": 33300,
	"./pisces/idle/7.png": 72284,
	"./pisces/idle/8.png": 42974,
	"./pisces/idle/9.png": 57674,
	"./pisces/tap/0.png": 56449,
	"./pisces/tap/1.png": 68280,
	"./pisces/tap/10.png": 47163,
	"./pisces/tap/2.png": 3685,
	"./pisces/tap/3.png": 85663,
	"./pisces/tap/4.png": 48458,
	"./pisces/tap/5.png": 89349,
	"./pisces/tap/6.png": 60325,
	"./pisces/tap/7.png": 46182,
	"./pisces/tap/8.png": 35596,
	"./pisces/tap/9.png": 42354,
	"./rappit/act1/0.png": 38109,
	"./rappit/act1/1.png": 59493,
	"./rappit/act1/10.png": 11211,
	"./rappit/act1/2.png": 5229,
	"./rappit/act1/3.png": 83338,
	"./rappit/act1/4.png": 85711,
	"./rappit/act1/5.png": 71158,
	"./rappit/act1/6.png": 36292,
	"./rappit/act1/7.png": 12299,
	"./rappit/act1/8.png": 20997,
	"./rappit/act1/9.png": 31976,
	"./rappit/act2/0.png": 57156,
	"./rappit/act2/1.png": 80964,
	"./rappit/act2/10.png": 94792,
	"./rappit/act2/2.png": 17916,
	"./rappit/act2/3.png": 96975,
	"./rappit/act2/4.png": 95337,
	"./rappit/act2/5.png": 8960,
	"./rappit/act2/6.png": 39579,
	"./rappit/act2/7.png": 47865,
	"./rappit/act2/8.png": 99647,
	"./rappit/act2/9.png": 21874,
	"./rappit/idle/0.png": 44128,
	"./rappit/idle/1.png": 66171,
	"./rappit/idle/2.png": 847,
	"./rappit/idle/3.png": 10146,
	"./rappit/idle/4.png": 13506,
	"./rappit/idle/5.png": 55034,
	"./rappit/tap/0.png": 49173,
	"./rappit/tap/1.png": 57291,
	"./rappit/tap/2.png": 77901,
	"./rappit/tap/3.png": 31882,
	"./rappit/tap/4.png": 19795,
	"./rappit/tap/5.png": 28882,
	"./rappit/tap/6.png": 89525,
	"./sandy/act1/0.png": 40444,
	"./sandy/act1/1.png": 32371,
	"./sandy/act1/10.png": 83680,
	"./sandy/act1/2.png": 81146,
	"./sandy/act1/3.png": 37688,
	"./sandy/act1/4.png": 32448,
	"./sandy/act1/5.png": 52324,
	"./sandy/act1/6.png": 64614,
	"./sandy/act1/7.png": 4107,
	"./sandy/act1/8.png": 97615,
	"./sandy/act1/9.png": 84643,
	"./sandy/act2/0.png": 5460,
	"./sandy/act2/1.png": 3814,
	"./sandy/act2/10.png": 6316,
	"./sandy/act2/2.png": 24515,
	"./sandy/act2/3.png": 56482,
	"./sandy/act2/4.png": 57346,
	"./sandy/act2/5.png": 31935,
	"./sandy/act2/6.png": 83204,
	"./sandy/act2/7.png": 39978,
	"./sandy/act2/8.png": 98106,
	"./sandy/act2/9.png": 66416,
	"./sandy/act3/0.png": 64580,
	"./sandy/act3/1.png": 35888,
	"./sandy/act3/10.png": 18856,
	"./sandy/act3/2.png": 75548,
	"./sandy/act3/3.png": 57433,
	"./sandy/act3/4.png": 57605,
	"./sandy/act3/5.png": 59155,
	"./sandy/act3/6.png": 85465,
	"./sandy/act3/7.png": 61728,
	"./sandy/act3/8.png": 39241,
	"./sandy/act3/9.png": 3193,
	"./sandy/act4/0.png": 90479,
	"./sandy/act4/1.png": 11726,
	"./sandy/act4/10.png": 98442,
	"./sandy/act4/2.png": 20094,
	"./sandy/act4/3.png": 15844,
	"./sandy/act4/4.png": 48175,
	"./sandy/act4/5.png": 33245,
	"./sandy/act4/6.png": 91201,
	"./sandy/act4/7.png": 3246,
	"./sandy/act4/8.png": 78532,
	"./sandy/act4/9.png": 49538,
	"./sandy/idle/0.png": 73096,
	"./sandy/idle/1.png": 21820,
	"./sandy/idle/10.png": 16651,
	"./sandy/idle/2.png": 57086,
	"./sandy/idle/3.png": 30925,
	"./sandy/idle/4.png": 35238,
	"./sandy/idle/5.png": 33067,
	"./sandy/idle/6.png": 7750,
	"./sandy/idle/7.png": 32066,
	"./sandy/idle/8.png": 62270,
	"./sandy/idle/9.png": 34986,
	"./sandy/tap/0.png": 57300,
	"./sandy/tap/1.png": 45709,
	"./sandy/tap/10.png": 330,
	"./sandy/tap/2.png": 6532,
	"./sandy/tap/3.png": 43920,
	"./sandy/tap/4.png": 36543,
	"./sandy/tap/5.png": 10631,
	"./sandy/tap/6.png": 64039,
	"./sandy/tap/7.png": 30452,
	"./sandy/tap/8.png": 51473,
	"./sandy/tap/9.png": 56076,
	"./shojo/act1/0.png": 81574,
	"./shojo/act1/1.png": 55596,
	"./shojo/act1/10.png": 8775,
	"./shojo/act1/2.png": 48662,
	"./shojo/act1/3.png": 81543,
	"./shojo/act1/4.png": 59133,
	"./shojo/act1/5.png": 98070,
	"./shojo/act1/6.png": 45240,
	"./shojo/act1/7.png": 21147,
	"./shojo/act1/8.png": 84749,
	"./shojo/act1/9.png": 42203,
	"./shojo/idle/0.png": 71883,
	"./shojo/idle/1.png": 78058,
	"./shojo/idle/2.png": 85900,
	"./shojo/idle/3.png": 95043,
	"./shojo/idle/4.png": 21046,
	"./shojo/idle/5.png": 32470,
	"./shojo/idle/6.png": 88672,
	"./shojo/idle/7.png": 54086,
	"./shojo/idle/8.png": 25347,
	"./shojo/tap/0.png": 12431,
	"./shojo/tap/1.png": 79091,
	"./shojo/tap/2.png": 13929,
	"./shojo/tap/3.png": 77881,
	"./shojo/tap/4.png": 387,
	"./shojo/tap/5.png": 3998,
	"./shojo/tap/6.png": 6174,
	"./shojo/tap/7.png": 37816,
	"./shojo/tap/8.png": 22455,
	"./spike/act1/0.png": 37947,
	"./spike/act1/1.png": 89025,
	"./spike/act1/10.png": 79881,
	"./spike/act1/2.png": 24002,
	"./spike/act1/3.png": 62654,
	"./spike/act1/4.png": 37005,
	"./spike/act1/5.png": 193,
	"./spike/act1/6.png": 28132,
	"./spike/act1/7.png": 53495,
	"./spike/act1/8.png": 55538,
	"./spike/act1/9.png": 88861,
	"./spike/idle/0.png": 87891,
	"./spike/idle/1.png": 81573,
	"./spike/idle/10.png": 17239,
	"./spike/idle/2.png": 50377,
	"./spike/idle/3.png": 57451,
	"./spike/idle/4.png": 75695,
	"./spike/idle/5.png": 5407,
	"./spike/idle/6.png": 28514,
	"./spike/idle/7.png": 98587,
	"./spike/idle/8.png": 64816,
	"./spike/idle/9.png": 82101,
	"./spike/tap/0.png": 62824,
	"./spike/tap/1.png": 85391,
	"./spike/tap/10.png": 190,
	"./spike/tap/2.png": 66181,
	"./spike/tap/3.png": 92253,
	"./spike/tap/4.png": 4473,
	"./spike/tap/5.png": 3486,
	"./spike/tap/6.png": 79527,
	"./spike/tap/7.png": 41095,
	"./spike/tap/8.png": 63754,
	"./spike/tap/9.png": 34387,
	"./wako/act1/0.png": 99883,
	"./wako/act1/1.png": 82735,
	"./wako/act1/10.png": 12890,
	"./wako/act1/2.png": 75944,
	"./wako/act1/3.png": 77927,
	"./wako/act1/4.png": 70801,
	"./wako/act1/5.png": 65038,
	"./wako/act1/6.png": 92371,
	"./wako/act1/7.png": 11616,
	"./wako/act1/8.png": 39467,
	"./wako/act1/9.png": 96629,
	"./wako/idle/0.png": 8246,
	"./wako/idle/1.png": 14630,
	"./wako/idle/10.png": 21282,
	"./wako/idle/2.png": 95731,
	"./wako/idle/3.png": 82904,
	"./wako/idle/4.png": 7664,
	"./wako/idle/5.png": 4985,
	"./wako/idle/6.png": 86246,
	"./wako/idle/7.png": 95856,
	"./wako/idle/8.png": 10526,
	"./wako/idle/9.png": 19408,
	"./wako/tap/0.png": 58510,
	"./wako/tap/1.png": 48607,
	"./wako/tap/10.png": 28236,
	"./wako/tap/2.png": 56168,
	"./wako/tap/3.png": 35820,
	"./wako/tap/4.png": 363,
	"./wako/tap/5.png": 26758,
	"./wako/tap/6.png": 79041,
	"./wako/tap/7.png": 95891,
	"./wako/tap/8.png": 48174,
	"./wako/tap/9.png": 55459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28983;